export default {
  actionType: {
    navigate: '页面跳转',
    scan: '扫码操作',
    dialog: '弹窗操作',
    custom: '自定义链接',
  },
  end: {
    member: '会员端',
    mall: '积分商城端',
    h5Scan: 'H5扫码端',
  },
  link: {
    home: '首页',
    scan: '扫码验真',
    myGifts: '我的奖品',
    myPointOrders: '积分订单',
    afterSale: '售后反馈',
    growth: '成长值明细',
    benefits: '会员权益',
    login: '登录页',
  },
  guard: {
    login: '需要登录',
  },
  extra: {
    params: '参数',
    dialogTitle: '弹窗标题',
    dialogContent: '弹窗内容',
  },
};
